import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

/**
 * @param {{
 *   drawing: object,
 *   onEdit?: (drawing: object) => void,
 *   onDelete?: (drawing: object) => void,
 *   iconSize?: number,
 * }} props
 */
export default function DrawingActionsMenu({
  drawing,
  onEdit,
  onDelete,
  iconSize = 20,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const hasActions = Boolean(onEdit || onDelete);

  const handleClose = () => setAnchorEl(null);

  if (!hasActions) return null;

  return (
    <>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
        aria-label="Drawing actions"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreVertIcon sx={{ fontSize: iconSize, color: "#64748B" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: "8px",
              minWidth: 140,
              boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              mt: 0.5,
            },
          },
        }}
      >
        {onEdit ? (
          <MenuItem
            onClick={() => {
              handleClose();
              onEdit(drawing);
            }}
            sx={{ fontSize: 14, py: 1 }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <EditOutlinedIcon fontSize="small" sx={{ color: "#364153" }} />
            </ListItemIcon>
            <ListItemText primary="Edit" />
          </MenuItem>
        ) : null}
        {onDelete ? (
          <MenuItem
            onClick={() => {
              handleClose();
              onDelete(drawing);
            }}
            sx={{ fontSize: 14, py: 1, color: "#DC2626" }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <DeleteOutlineIcon fontSize="small" sx={{ color: "#DC2626" }} />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              primaryTypographyProps={{ sx: { color: "#DC2626" } }}
            />
          </MenuItem>
        ) : null}
      </Menu>
    </>
  );
}
